export default __webpack_public_path__ + "static/media/RobotExample.09041864.png";